import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useAnalysisStore } from '../../stores/analysisStore';
import O2KineticsWorkspace from './O2KineticsWorkspace';
import RawDataWorkspace from './RawDataWorkspace';
import WorkspaceSelector from './WorkspaceSelector';

const AnalysisPanel = ({ tabId }) => {
  const activeWorkspace = useAnalysisStore(
    (state) => state.openFiles[tabId]?.activeWorkspace || 'rawData',
  );
  const setActiveWorkspace = useAnalysisStore((state) => state.setActiveWorkspace);
  const isLoading = useAnalysisStore((state) => state.isLoading);
  const tab = useAnalysisStore((state) => state.openFiles[tabId]);
  const hasChambers = tab && Object.keys(tab.chambers || {}).length > 0;

  const handleWorkspaceChange = (workspace) => {
    setActiveWorkspace(tabId, workspace);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        bgcolor: '#D8DCDF',
      }}
    >
      <WorkspaceSelector value={activeWorkspace} onChange={handleWorkspaceChange} />
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        {isLoading && !hasChambers ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              gap: 1.5,
            }}
          >
            <CircularProgress size={28} sx={{ color: '#394b57' }} />
            <Typography sx={{ color: '#7d8d97', fontSize: 13 }}>
              Loading measurement data...
            </Typography>
          </Box>
        ) : (
          <>
            {activeWorkspace === 'rawData' && <RawDataWorkspace tabId={tabId} />}
            {activeWorkspace === 'o2kinetics' && <O2KineticsWorkspace tabId={tabId} />}
          </>
        )}
      </Box>
    </Box>
  );
};

export default AnalysisPanel;
